var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2549_16105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 2.5H8.125L6.375 0.75H2C1.0375 0.75 0.25 1.5375 0.25 2.5V6H17.75V4.25C17.75 3.2875 16.9625 2.5 16 2.5Z",
    fill: "#D20F3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 2.5H2C1.0375 2.5 0.25 3.2875 0.25 4.25V13C0.25 13.9625 1.0375 14.75 2 14.75H16C16.9625 14.75 17.75 13.9625 17.75 13V4.25C17.75 3.2875 16.9625 2.5 16 2.5Z",
    fill: "#D20F3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2549_16105"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.7ca919c7bf6639ff7eb85846866be08e.svg";
export { ForwardRef as ReactComponent };